import Backbone from 'backbone'
import bootslideOption from 'scoreboard/components/bootslide/option.hbs'

/**
 * Options to be passed into a bootslide-clickable-menu. Displays and handles click
 * events for the individual bootslide options.
 */
const BootslideClickableMenuOption = Backbone.View.extend({
	events: {
		'click': '_onClick'
	},

	render() {
		this.$el.html(bootslideOption({
			icon: this.icon,
			label: this.label
		})).addClass(this.icon)
		this.className = this.icon
		return this
	}
})

export default BootslideClickableMenuOption

BootslideClickableMenuOption.__filename__ = 'components/bootslide/bootslide-clickable-menu-option.js'
